import MergePOModal from './MergePOModal';
import SplitPOModal from './SplitPOModal';
import PurchaseReturnBatch from './PurchaseReturnBatch';
import ConvertToSOModal from './ConvertToSOModal';

const purchaseManagement = {
  MergePOModal,
  SplitPOModal,
  PurchaseReturnBatch,
  ConvertToSOModal,
}

export default purchaseManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/purchaseManagement/index.jsx